import { render, staticRenderFns } from "./genres-picker.vue?vue&type=template&id=f76d3dfc&scoped=true"
import script from "./genres-picker.vue?vue&type=script&setup=true&lang=js"
export * from "./genres-picker.vue?vue&type=script&setup=true&lang=js"
import style0 from "./genres-picker.vue?vue&type=style&index=0&id=f76d3dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76d3dfc",
  null
  
)

export default component.exports